/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWERP depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

VIEWER.Editor = function () {
    this.signals = {
        objectSelected: undefined,
        objectChanged: undefined
    };
};

VIEWER.Editor.prototype = {
    /**
     * Gets scene
     * @returns {VIEWER.Scene}
     */
    getScene: function () { },

    /**
    * Gets asset type
    * @param {LANA3D.Scene}
    */
    setScene: function (scene) { },

    addNode: function (node) { },
    selectNode: function (node) { },
    deleteNode: function (node) { },
    notifySelectedNodeUpdated: function () { },
    getDomElement: function () { },
    resize: function () { },
    clearScene: function () { }
};

VIEWER.Editor.create = function () { };

VIEWER.EditorControls = function (object, domElement) {

};

VIEWER.EditorControls.prototype = {

};


(function (VIEWER) {
    (function (ThreeImpl) {

        var _interface = VIEWER.EditorControls;

        function EditorControlsImpl(object, domElement) {
            _interface.apply(this, object, domElement);

            domElement = (domElement !== undefined) ? domElement : document;

            // API

            this.cameraMoveMode = false;
            this.enabled = true;
            this.center = new LANA3D.Vector3();
            this.panSpeed = 0.001;
            this.zoomSpeed = 0.002;
            this.rotationSpeed = 0.005;

            // internals

            var scope = this;
            var vector = new LANA3D.Vector3();

            var STATE = { NONE: - 1, ROTATE: 0, ZOOM: 1, PAN: 2 };
            var state = STATE.NONE;

            var center = this.center;
            var normalMatrix = new THREE.Matrix3();
            var pointer = new LANA3D.Vector2();
            var pointerOld = new LANA3D.Vector2();
            var spherical = new THREE.Spherical();

            // events

            var changeEvent = { type: 'change' };

            this.focus = function (target) {

                var box = new THREE.Box3().setFromObject(target);
                object.lookAt(center.copy(box.getCenter()));
                //scope.dispatchEvent( changeEvent );
                scope.cameraMoveMode = false;

            };


            this.pan = function (delta) {


                if (delta.x === 0 && delta.y === 0 && delta.z === 0) {
                    scope.cameraMoveMode = false;
                }
                else {
                    scope.cameraMoveMode = true;

                }
                var distance = object.position.distanceTo(center);

                delta.multiplyScalar(distance * scope.panSpeed);


                delta.applyMatrix3(normalMatrix.getNormalMatrix(object.matrix));

                if (object.position.y + delta.y < 0.12) {
                    return;
                }
                object.position.add(delta);
                center.add(delta);


                if (object.position.y < 0.12) {
                    object.position.y = 0.12;
                }

                //scope.dispatchEvent( changeEvent );

            };

            this.zoom = function (delta) {

                if (delta.x === 0 && delta.y === 0 && delta.z === 0) {
                    scope.cameraMoveMode = false;
                }
                else {
                    scope.cameraMoveMode = true;
                }

                var distance = object.position.distanceTo(center);

                delta.multiplyScalar(distance * scope.zoomSpeed);


                if (delta.length() > distance) {
                    return;

                }

                delta.applyMatrix3(normalMatrix.getNormalMatrix(object.matrix));


                object.position.add(delta);
                if (object.position.y < 0.12) {
                    object.position.y = 0.12;
                }

                //scope.dispatchEvent( changeEvent );

            };

            this.rotate = function (delta) {

                if (delta.x === 0 && delta.y === 0 && delta.z === 0) {
                    scope.cameraMoveMode = false;
                }
                else {
                    scope.cameraMoveMode = true;
                }

                vector.copy(object.position).sub(center);

                spherical.setFromVector3(vector);

                spherical.theta += delta.x;
                spherical.phi += delta.y;

                spherical.makeSafe();

                vector.setFromSpherical(spherical);

                if (vector.y < 0.0) return;

                if (center.y < 0) {
                    center.y = 0;
                }

                object.position.copy(center).add(vector);
                object.lookAt(center);

                //this.cameraMoveMode = false;

                //scope.dispatchEvent( changeEvent );

            };

            this.reset = function () {
                center = new LANA3D.Vector3(0, 0, 0);
                object.position.copy(new LANA3D.Vector3(40, 10, 0));
                object.lookAt(center);
                state = STATE.NONE;

                scope.cameraMoveMode = false;

            };

            // mouse


            function onMouseDown(event) {


                if (scope.enabled === false) return;


                if (event.button === 0) {

                    state = STATE.ROTATE;

                } else if (event.button === 1) {

                    state = STATE.ZOOM;

                } else if (event.button === 2) {

                    state = STATE.PAN;

                }



                pointerOld.set(event.clientX, event.clientY);

                //if(scope.cameraMoveMode){
                domElement.addEventListener('mousemove', onMouseMove, false);
                domElement.addEventListener('mouseup', onMouseUp, false);
                domElement.addEventListener('mouseout', onMouseUp, false);
                domElement.addEventListener('dblclick', onMouseUp, false);
                //}

                scope.cameraMoveMode = false;

            }

            function onMouseMove(event) {


                if (scope.enabled === false) return;

                //console.log("onMouseMove this.cameraMoveMode = true;");
                //this.cameraMoveMode = true;

                pointer.set(event.clientX, event.clientY);

                var movementX = pointer.x - pointerOld.x;
                var movementY = pointer.y - pointerOld.y;

                //if (movementY < 0.1){ movementY = 0.1;}

                if (state === STATE.ROTATE) {

                    scope.rotate(new THREE.Vector3(- movementX * scope.rotationSpeed, - movementY * scope.rotationSpeed, 0));


                } else if (state === STATE.ZOOM) {

                    scope.zoom(new THREE.Vector3(0, 0, movementY));

                } else if (state === STATE.PAN) {

                    scope.pan(new THREE.Vector3(- movementX, movementY, 0));

                }

                pointerOld.set(event.clientX, event.clientY);

            }

            function onMouseUp(event) {


                domElement.removeEventListener('mousemove', onMouseMove, false);
                domElement.removeEventListener('mouseup', onMouseUp, false);
                domElement.removeEventListener('mouseout', onMouseUp, false);
                domElement.removeEventListener('dblclick', onMouseUp, false);

                //this.cameraMoveMode = false;

                state = STATE.NONE;

            }

            function onMouseWheel(event) {

                event.preventDefault();

                // if ( scope.enabled === false ) return;

                scope.zoom(new THREE.Vector3(0, 0, event.deltaY));

            }

            function onWheel(event) {

                event.preventDefault();

                // if ( scope.enabled === false ) return;

                scope.zoom(new THREE.Vector3(0, 0, event.deltaY));

            }

            function contextmenu(event) {

                event.preventDefault();

            }

            this.dispose = function () {

                domElement.removeEventListener('contextmenu', contextmenu, false);
                domElement.removeEventListener('mousedown', onMouseDown, false);
                //domElement.removeEventListener( 'wheel', onMouseWheel, false );
                domElement.removeEventListener('wheel', onWheel, false);

                domElement.removeEventListener('mousemove', onMouseMove, false);
                domElement.removeEventListener('mouseup', onMouseUp, false);
                domElement.removeEventListener('mouseout', onMouseUp, false);
                domElement.removeEventListener('dblclick', onMouseUp, false);

                domElement.removeEventListener('touchstart', touchStart, false);
                domElement.removeEventListener('touchmove', touchMove, false);

            };

            domElement.addEventListener('contextmenu', contextmenu, false);
            domElement.addEventListener('mousedown', onMouseDown, false);
            //domElement.addEventListener( 'wheel', onMouseWheel, false );
            domElement.addEventListener('wheel', onWheel, false);

            // touch

            var touch = new THREE.Vector3();

            var touches = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];
            var prevTouches = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];

            var prevDistance = null;

            function touchStart(event) {

                if (scope.enabled === false) return;

                switch (event.touches.length) {

                    case 1:
                        touches[0].set(event.touches[0].pageX, event.touches[0].pageY, 0);
                        touches[1].set(event.touches[0].pageX, event.touches[0].pageY, 0);
                        break;

                    case 2:
                        touches[0].set(event.touches[0].pageX, event.touches[0].pageY, 0);
                        touches[1].set(event.touches[1].pageX, event.touches[1].pageY, 0);
                        prevDistance = touches[0].distanceTo(touches[1]);
                        break;

                }

                prevTouches[0].copy(touches[0]);
                prevTouches[1].copy(touches[1]);

            }


            function touchMove(event) {

                if (scope.enabled === false) return;

                event.preventDefault();
                event.stopPropagation();

                function getClosest(touch, touches) {

                    var closest = touches[0];

                    for (var i in touches) {

                        if (closest.distanceTo(touch) > touches[i].distanceTo(touch)) closest = touches[i];

                    }

                    return closest;

                }

                switch (event.touches.length) {

                    case 1:
                        touches[0].set(event.touches[0].pageX, event.touches[0].pageY, 0);
                        touches[1].set(event.touches[0].pageX, event.touches[0].pageY, 0);
                        scope.rotate(touches[0].sub(getClosest(touches[0], prevTouches)).multiplyScalar(- scope.rotationSpeed));
                        break;

                    case 2:
                        touches[0].set(event.touches[0].pageX, event.touches[0].pageY, 0);
                        touches[1].set(event.touches[1].pageX, event.touches[1].pageY, 0);
                        distance = touches[0].distanceTo(touches[1]);
                        scope.zoom(new THREE.Vector3(0, 0, prevDistance - distance));
                        prevDistance = distance;


                        var offset0 = touches[0].clone().sub(getClosest(touches[0], prevTouches));
                        var offset1 = touches[1].clone().sub(getClosest(touches[1], prevTouches));
                        offset0.x = - offset0.x;
                        offset1.x = - offset1.x;

                        scope.pan(offset0.add(offset1).multiplyScalar(0.5));

                        break;

                }

                prevTouches[0].copy(touches[0]);
                prevTouches[1].copy(touches[1]);

            }

            domElement.addEventListener('touchstart', touchStart, false);
            domElement.addEventListener('touchmove', touchMove, false);

            //key event
            /*function onKeyDown( event ) {

                switch( event.keyCode ) {
                    case 17:  
                    scope.cameraMoveMode = true; 
                    break;
                }
            }

            function onKeyUp( event ) {

                switch( event.keyCode ) {
                    case 17:  
                    scope.cameraMoveMode = false; 
                    break;
                }
            }*/

            //document.addEventListener( 'keydown', onKeyDown, false );
            //document.addEventListener( 'keyup', onKeyUp, false );

        }

        VIEWER.EditorControls = function () {
            EditorControlsImpl.apply(this, arguments);
        };

        EditorControlsImpl.prototype = Object.create(VIEWER.EditorControls.prototype);

        EditorControlsImpl.prototype.updateObject = function (camera, target) {
            this.object = camera;
            this.focus(target);
        }

        EditorControlsImpl.prototype.resetCamera = function (position, target) {
            /*this.object.position.copy( position );
            this.object.lookAt(target);*/
            this.reset();
        }

        VIEWER.EditorControls.prototype = EditorControlsImpl.prototype;

    })(VIEWER.Three || (VIEWER.Three = {}));
})(VIEWER || (VIEWER = {}));
VIEWER.Viewport = function (editor) {

};

VIEWER.Viewport.prototype = {

};

(function (VIEWER) {
	(function (ThreeImpl) {

		var _interface = VIEWER.Viewport;

		function ViewportImpl(editor) {
			_interface.apply(this, editor);

			var signals = editor.signals;

			var container = new UI.Panel();
			container.setId('viewport');
			container.setPosition('absolute');

			//container.add( new Viewport.Info( editor ) );

			this.dom = container.dom;
			//

			var renderer = null;

			var camera = editor.camera;
			var scene = editor.scene;
			var sceneHelpers = editor.sceneHelpers;

			var objects = [];

			//

			//var vrEffect, vrControls;

			/*if ( WEBVR.isAvailable() === true ) {

				var vrCamera = new THREE.PerspectiveCamera();
				vrCamera.projectionMatrix = camera.projectionMatrix;
				camera.add( vrCamera );

			}*/

			// helpers

			var grid = new THREE.GridHelper(60, 60);
			sceneHelpers.add(grid);

			//

			var box = new THREE.Box3();

			var selectionBox = new THREE.BoxHelper();
			selectionBox.material.depthTest = false;
			selectionBox.material.transparent = true;
			selectionBox.visible = false;
			sceneHelpers.add(selectionBox);

			var objectPositionOnDown = null;
			var objectRotationOnDown = null;
			var objectScaleOnDown = null;

			var transformControls = new THREE.TransformControls(camera, container.dom);
			transformControls.addEventListener('change', function () {

				var object = transformControls.object;

				if (object !== undefined) {

					selectionBox.update(object);

					if (editor.helpers[object.id] !== undefined) {

						editor.helpers[object.id].update();

					}

					signals.refreshSidebarObject3D.dispatch(object);

				}

				render();

			});
			transformControls.addEventListener('mouseDown', function () {

				var object = transformControls.object;

				objectPositionOnDown = object.position.clone();
				objectRotationOnDown = object.rotation.clone();
				objectScaleOnDown = object.scale.clone();

				controls.enabled = false;

			});
			transformControls.addEventListener('mouseUp', function () {

				var object = transformControls.object;

				if (object !== undefined) {

					switch (transformControls.getMode()) {

						case 'translate':

							if (!objectPositionOnDown.equals(object.position)) {

								editor.execute(new SetPositionCommand(object, object.position, objectPositionOnDown));

							}

							break;

						case 'rotate':

							if (!objectRotationOnDown.equals(object.rotation)) {

								editor.execute(new SetRotationCommand(object, object.rotation, objectRotationOnDown));

							}

							break;

						case 'scale':

							if (!objectScaleOnDown.equals(object.scale)) {

								editor.execute(new SetScaleCommand(object, object.scale, objectScaleOnDown));

							}

							break;

					}

				}

				controls.enabled = true;

			});

			sceneHelpers.add(transformControls);

			// object picking

			var raycaster = new THREE.Raycaster();
			var mouse = new THREE.Vector2();

			// events

			function getIntersects(point, objects) {

				mouse.set((point.x * 2) - 1, - (point.y * 2) + 1);

				raycaster.setFromCamera(mouse, camera);

				return raycaster.intersectObjects(objects);

			}

			var onDownPosition = new THREE.Vector2();
			var onUpPosition = new THREE.Vector2();
			var onDoubleClickPosition = new THREE.Vector2();

			function getMousePosition(dom, x, y) {

				var rect = dom.getBoundingClientRect();
				return [(x - rect.left) / rect.width, (y - rect.top) / rect.height];

			}

			function handleClick() {

				if (onDownPosition.distanceTo(onUpPosition) === 0) {

					var intersects = getIntersects(onUpPosition, objects);

					if (intersects.length > 0) {

						var object = intersects[0].object;

						if (object.userData.object !== undefined) {

							// helper

							editor.select(object.userData.object);

						} else {

							editor.select(object);

						}

					} else {

						editor.select(null);

					}

					render();

				}

			}

			function onMouseDown(event) {

				event.preventDefault();

				var array = getMousePosition(container.dom, event.clientX, event.clientY);
				onDownPosition.fromArray(array);

				document.addEventListener('mouseup', onMouseUp, false);

			}

			function onMouseUp(event) {

				var array = getMousePosition(container.dom, event.clientX, event.clientY);
				onUpPosition.fromArray(array);

				handleClick();

				document.removeEventListener('mouseup', onMouseUp, false);

			}

			function onTouchStart(event) {

				var touch = event.changedTouches[0];

				var array = getMousePosition(container.dom, touch.clientX, touch.clientY);
				onDownPosition.fromArray(array);

				document.addEventListener('touchend', onTouchEnd, false);

			}

			function onTouchEnd(event) {

				var touch = event.changedTouches[0];

				var array = getMousePosition(container.dom, touch.clientX, touch.clientY);
				onUpPosition.fromArray(array);

				handleClick();

				document.removeEventListener('touchend', onTouchEnd, false);

			}

			function onDoubleClick(event) {

				var array = getMousePosition(container.dom, event.clientX, event.clientY);
				onDoubleClickPosition.fromArray(array);

				var intersects = getIntersects(onDoubleClickPosition, objects);

				if (intersects.length > 0) {

					var intersect = intersects[0];

					signals.objectFocused.dispatch(intersect.object);

				}

			}

			container.dom.addEventListener('mousedown', onMouseDown, false);
			container.dom.addEventListener('touchstart', onTouchStart, false);
			container.dom.addEventListener('dblclick', onDoubleClick, false);

			// controls need to be added *after* main logic,
			// otherwise controls.enabled doesn't work.

			this.controls = new VIEWER.EditorControls(camera, container.dom);
			//	controls.addEventListener( 'change', function () {

			//		transformControls.update();
			//		signals.cameraChanged.dispatch( camera );

			//	} );

			// signals

			signals.editorCleared.add(function () {

				controls.center.set(0, 0, 0);
				render();

			});

			/*signals.enterVR.add( function () {

				vrEffect.isPresenting ? vrEffect.exitPresent() : vrEffect.requestPresent();

			} );*/

			signals.themeChanged.add(function (value) {

				switch (value) {

					case 'css/light.css':
						sceneHelpers.remove(grid);
						grid = new THREE.GridHelper(60, 60, 0x444444, 0x888888);
						sceneHelpers.add(grid);
						break;
					case 'css/dark.css':
						sceneHelpers.remove(grid);
						grid = new THREE.GridHelper(60, 60, 0xbbbbbb, 0x888888);
						sceneHelpers.add(grid);
						break;

				}

				render();

			});

			signals.transformModeChanged.add(function (mode) {

				transformControls.setMode(mode);

			});

			signals.snapChanged.add(function (dist) {

				transformControls.setTranslationSnap(dist);

			});

			signals.spaceChanged.add(function (space) {

				transformControls.setSpace(space);

			});

			signals.rendererChanged.add(function (newRenderer) {

				if (renderer !== null) {

					container.dom.removeChild(renderer.domElement);

				}

				renderer = newRenderer;

				renderer.autoClear = false;
				renderer.autoUpdateScene = false;
				renderer.setPixelRatio(window.devicePixelRatio);
				renderer.setSize(container.dom.offsetWidth, container.dom.offsetHeight);

				container.dom.appendChild(renderer.domElement);

				/*if ( WEBVR.isAvailable() === true ) {

					vrControls = new THREE.VRControls( vrCamera );
					vrEffect = new THREE.VREffect( renderer );

					window.addEventListener( 'vrdisplaypresentchange', function ( event ) {

						effect.isPresenting ? signals.enteredVR.dispatch() : signals.exitedVR.dispatch();

					}, false );

				}*/

				render();

			});

			signals.sceneGraphChanged.add(function () {

				render();

			});

			signals.cameraChanged.add(function () {

				render();

			});

			signals.objectSelected.add(function (object) {

				selectionBox.visible = false;
				transformControls.detach();

				if (object !== null && object !== scene) {

					box.setFromObject(object);

					if (box.isEmpty() === false) {

						selectionBox.update(box);
						selectionBox.visible = true;

					}

					transformControls.attach(object);

				}

				render();

			});

			signals.objectFocused.add(function (object) {

				controls.focus(object);

			});

			signals.geometryChanged.add(function (object) {

				if (object !== undefined) {

					selectionBox.update(object);

				}

				render();

			});

			signals.objectAdded.add(function (object) {

				object.traverse(function (child) {

					objects.push(child);

				});

			});

			signals.objectChanged.add(function (object) {

				if (editor.selected === object) {

					selectionBox.update(object);
					transformControls.update();

				}

				if (object instanceof THREE.PerspectiveCamera) {

					object.updateProjectionMatrix();

				}

				if (editor.helpers[object.id] !== undefined) {

					editor.helpers[object.id].update();

				}

				render();

			});

			signals.objectRemoved.add(function (object) {

				object.traverse(function (child) {

					objects.splice(objects.indexOf(child), 1);

				});

			});

			signals.helperAdded.add(function (object) {

				objects.push(object.getObjectByName('picker'));

			});

			signals.helperRemoved.add(function (object) {

				objects.splice(objects.indexOf(object.getObjectByName('picker')), 1);

			});

			signals.materialChanged.add(function (material) {

				render();

			});

			// fog

			signals.sceneBackgroundChanged.add(function (backgroundColor) {

				scene.background.setHex(backgroundColor);

				render();

			});

			var currentFogType = null;

			signals.sceneFogChanged.add(function (fogType, fogColor, fogNear, fogFar, fogDensity) {

				if (currentFogType !== fogType) {

					switch (fogType) {

						case 'None':
							scene.fog = null;
							break;
						case 'Fog':
							scene.fog = new THREE.Fog();
							break;
						case 'FogExp2':
							scene.fog = new THREE.FogExp2();
							break;

					}

					currentFogType = fogType;

				}

				if (scene.fog instanceof THREE.Fog) {

					scene.fog.color.setHex(fogColor);
					scene.fog.near = fogNear;
					scene.fog.far = fogFar;

				} else if (scene.fog instanceof THREE.FogExp2) {

					scene.fog.color.setHex(fogColor);
					scene.fog.density = fogDensity;

				}

				render();

			});

			//

			signals.windowResize.add(function () {

				// TODO: Move this out?

				editor.DEFAULT_CAMERA.aspect = container.dom.offsetWidth / container.dom.offsetHeight;
				editor.DEFAULT_CAMERA.updateProjectionMatrix();

				camera.aspect = container.dom.offsetWidth / container.dom.offsetHeight;
				camera.updateProjectionMatrix();

				renderer.setSize(container.dom.offsetWidth, container.dom.offsetHeight);

				render();

			});

			signals.showGridChanged.add(function (showGrid) {

				grid.visible = showGrid;
				render();

			});

			//

			function animate() {

				requestAnimationFrame(animate);

				/*

				// animations

				if ( THREE.AnimationHandler.animations.length > 0 ) {

					THREE.AnimationHandler.update( 0.016 );

					for ( var i = 0, l = sceneHelpers.children.length; i < l; i ++ ) {

						var helper = sceneHelpers.children[ i ];

						if ( helper instanceof THREE.SkeletonHelper ) {

							helper.update();

						}

					}

				}
				*/

				/*if ( vrEffect && vrEffect.isPresenting ) {

					render();

				}*/

			}

			function render() {

				sceneHelpers.updateMatrixWorld();
				scene.updateMatrixWorld();

				/*if ( vrEffect && vrEffect.isPresenting ) {

					vrControls.update();

					camera.updateMatrixWorld();

					vrEffect.render( scene, vrCamera );
					vrEffect.render( sceneHelpers, vrCamera );

				} else {*/

				renderer.render(scene, camera);

				if (renderer instanceof THREE.RaytracingRenderer === false) {

					renderer.render(sceneHelpers, camera);

				}

				//}


			}

			requestAnimationFrame(animate);

			return container;

		};

		VIEWER.Viewport = function () {
			ViewportImpl.apply(this, arguments);
		};

		ViewportImpl.prototype = Object.create(VIEWER.Viewport.prototype);

		ViewportImpl.prototype.updateCamera = function (camera, target) {
			this.camera = camera;
			this.controls.updateObject(camera, target);
		}

		ViewportImpl.prototype.resetCamera = function (position, target) {
			//this.camera = camera;
			this.controls.resetCamera(position, target);
		}

		VIEWER.Viewport.prototype = ViewportImpl.prototype;

	})(VIEWER.Three || (VIEWER.Three = {}));
})(VIEWER || (VIEWER = {}));
/**
 * 
 * @namespace
 */
var VIEWER = VIEWER || {};

/**
 * Scene class
 * @constructor
 */
VIEWER.Scene = function () {

};

VIEWER.Scene.prototype = {

    _name: "",

    _sceneVisuNode: undefined,

    _sceneCollisionNode: undefined,


    /**
    * Gets scene name
    * @returns {string} name
    */
    getName: function () { },

    /**
    * Sets scene name
    * @param {string} name
    */
    setName: function (name) { },

    getSceneVisuNode: function () { },

    getSceneCollisionNode: function () { }
};

(function (VIEWER) {
    (function () {

        var _interface = VIEWER.Scene;

        function SceneImpl() {
            _interface.apply(this, arguments);

            this._useBezier = true;
            this._floorDetectOffset = 30;
            this._name = 'scene';
            this._sceneNode = LANA3D.NodeManager.getInstance().createNode('node');
            this._buildAreaSize = 4000;
        }

        VIEWER.Scene = function () {
            SceneImpl.apply(this, arguments);
        };

        SceneImpl.prototype = Object.create(VIEWER.Scene.prototype);

        SceneImpl.prototype.getName = function () {
            return this._name;
        };

        SceneImpl.prototype.setName = function (name) {
            this._name = name;
        };

        SceneImpl.prototype.setSceneNode = function (node) {
            //get bounding box
            var bbox = new THREE.Box3().setFromObject(node.getInternal());
            var maxSize = Math.max(bbox.max.z - bbox.min.z, bbox.max.x - bbox.min.x);
            this.setBuildAreaSize(Math.round(maxSize + (maxSize * 0.25)));
            this._sceneNode.addChild(node);
        };

        SceneImpl.prototype.clearSceneNode = function () {
            var children = this._sceneNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                this._sceneNode.removeChild(children[i]);
            }
        }

        SceneImpl.prototype.getSceneNode = function () {
            return this._sceneNode;
        };


        SceneImpl.prototype.loadSceneFromFile = function (files) {
            var self = this;

            var total = files.length;
            var progressCount = 0;
            $('#loadingModal').modal();


            function updateProgressBar() {
                progressCount++;
                var pBar = document.getElementById('progress-bar');
                if (pBar) {
                    pBar.value = progressCount / total;
                    document.getElementById('p').innerHTML = Math.round(pBar.value * 100) + "%";
                }

                if (progressCount >= total) {
                    $('#loadingModal').modal('hide');
                }
            }

            for (var i = 0; i < files.length; i++) {
                var file = "warehouse/" + files[i].substring(2);

                LANA3D.AssetManager.loadBundle(file, function (result) {
                    var o = result.scene;
                    self._sceneNode.addChild(o);
                    updateProgressBar();
                });

            }

        }

        SceneImpl.prototype.paintResourceStatus = function (status, node) {
            var n = node;
            var color;
            if (status == "0") {
                //ejecución -> verde
                color = 0x33cc33;
            }
            else if (status == "1") {
                //preparación -> amarilla
                color = 0xffff00;
            }
            else if (status == "2") {
                //sin actividad -> naranja
                color = 0xb54200;
            }
            else {
                //Indicencia -> rojo / azul (#3399ff) ? interrumpida/parada
                color = 0xff0000;
            }

            var bbox = new THREE.Box3().setFromObject(n[0].getInternal());
            var maxSize = Math.max(bbox.max.z - bbox.min.z, bbox.max.x - bbox.min.x);

            var geometry = LANA3D.AssetManager.createAsset("geometry.plane", maxSize, maxSize);
            geometry.getInternal().rotateX(- Math.PI / 2);
            var plane = LANA3D.NodeManager.getInstance().createNode("mesh", geometry, new LANA3D.Material());//new LANA3D.Mesh( geometry, new LANA3D.Material( { visible: false } ) );
            var texture = THREE.TextureLoader("img/aura.jpg");
            plane.setName("state_plane");
            plane.getInternal().material.color.set(color);
            plane.getInternal().material.map = texture;
            plane.getLocalTransform().getPosition().add(new LANA3D.Vector3(0, 0.002, 0));
            n[0].addChild(plane);
        }


        SceneImpl.prototype.paintStatus = function (status, type, node, dimensions) {
            var self = this;
            var status = status;
            var type = type;
            var d = dimensions;
            //var file = "models/caja.dae";
            var n = node;
            if (status == "0") {
                //bloqueada -> plano rojo sobre ubicación
                this.paintPlane(n, 0xff0000, d);

            }
            else if (status == "1") {
                //vacía -> plano verde sobre ubicación
                //this.paintPlane(n, 0x33cc33, d);

            }
            else if (status == "2") {
                //no llena -> caja alarilla (ocupada)
                this.paintItem(n, type, 50, d);
                this.paintPlane(n, 0xffff00, d);
            }
            else {
                //llena -> caja naranja
                this.paintItem(n, type, 101, d);
                this.paintPlane(n, 0xb54200, d);
            }
        }



        SceneImpl.prototype.paintPlane = function (node, color, dimensions) {
            var self = this;
            var dimensions = dimensions;
            var n = node;
            var color = color;
            var width = dimensions.w / 1000;
            var depth = dimensions.d / 1000;
            var height = dimensions.h / 1000;

            var childrenNodes = n[0].findChildrenByType('mesh', true);
            for (var i = 0; i < childrenNodes.length; i++) {
                if (childrenNodes[i]._internal.name.indexOf("plane") > -1) {
                    n[0].removeChild(childrenNodes[i]);
                }
            }
            var posy = -(height / 2) + 0.1;
            //var geometry = LANA3D.AssetManager.createAsset("geometry.plane",  0.8, 0.6);
            var geometry = LANA3D.AssetManager.createAsset("geometry.plane", depth - 0.1, width - 0.1);
            geometry.getInternal().rotateX(- Math.PI / 2);
            var plane = LANA3D.NodeManager.getInstance().createNode("mesh", geometry, new LANA3D.Material());//new LANA3D.Mesh( geometry, new LANA3D.Material( { visible: false } ) );
            var texture = THREE.TextureLoader("img/aura.jpg");
            plane.setName("state_plane");
            plane.getInternal().material.color.set(color);
            plane.getInternal().material.map = texture;
            plane.getLocalTransform().getPosition().add(new LANA3D.Vector3(0, posy, 0));
            n[0].addChild(plane);

        }

        SceneImpl.prototype.paintItem = function (node, type, percentage, dimensions) {
            var self = this;
            var n = node;
            var file; //= "models/caja.dae";
            var percentage = percentage;
            var color = 0xccff66;
            var dim = dimensions;
            var opacity = 1;

            if (type == "M") {
                file = "models/picking.dae"
            }
            else if (type == "C") {
                file = "models/casillero.dae"
            }
            else if (type == "H") {
                file = "models/caja.dae"
            }
            else if (type == "Z") {
                file = "models/palet.dae"
            }
            /*if (percentage == 0){
                //verde = vacía
                color = 0xccff66;
            }
            else if (percentage >= 100){
                //naranja = llena
                color = 0xff8000;
            }
            else{
                //amarilla = ocupada
                color = 0xffff00;
            }
            // Bloqueada? -> roja*/
            var childrenNodes = n[0].findChildrenByType('mesh', true);
            for (var i = 0; i < childrenNodes.length; i++) {
                var parent = childrenNodes[i].getParent();
                //var parentName = parent.getName();
                var grandParent = parent.getParent();
                var parentName = grandParent.getName();
                if (parentName.indexOf("casillero") > -1) {
                    opacity = childrenNodes[i]._internal.material.opacity;
                    parent.removeChild(childrenNodes[i]);
                }
                if (parentName.indexOf("caja") > -1) {
                    opacity = childrenNodes[i]._internal.material.opacity;
                    parent.removeChild(childrenNodes[i]);

                }
                if (parentName.indexOf("picking") > -1) {
                    opacity = childrenNodes[i]._internal.material.opacity;
                    parent.removeChild(childrenNodes[i]);

                }
                if (parentName.indexOf("palet") > -1) {
                    opacity = childrenNodes[i]._internal.material.opacity;//childrenNodes[i]._internal.material.opacity = 0;
                    parent.removeChild(childrenNodes[i]);

                }
            }

            (function (rfile, locationSize) {
                var locationSize = locationSize;
                var lsw = locationSize.w - 300;
                var lsd = locationSize.d - 300;
                var lsh = locationSize.h - 100;
                LANA3D.AssetManager.loadBundle(rfile, function (result) {
                    var o = result.scene;
                    o.getInternal().rotateX(Math.PI / 2);
                    var bbox = new THREE.Box3().setFromObject(o.getInternal());
                    var size = bbox.getSize();

                    var w = (lsw / 1000) / (size.z / 100);
                    var d = (lsd / 1000) / (size.x / 100);
                    var h = (lsh / 1000) / (size.y / 100);
                    if (type == "Z") {
                        var posy = lsh / 1000;
                        posy = posy / 2;
                        o.getLocalTransform().scale.set(d * 0.01, w * 0.01, 0.01);
                        var desp = posy * (-1);
                        o.getLocalTransform().getPosition().add(new LANA3D.Vector3(0, desp, 0));
                    }
                    else { o.getLocalTransform().scale.set(d * 0.01, w * 0.01, h * 0.01); }
                    //o._internal.children[1].children[0].children[0].material.opacity = opacity;
                    n[0].addChild(o);
                    //preserve transparency (not at plane)
                    var mesh = n[0].findChildrenByType('mesh', true);
                    for (var i = 0; mesh.length > i; i++) {
                        if (mesh[i]._internal.name.indexOf("state_plane") < 0) {
                            mesh[i]._internal.material.opacity = opacity;
                        }
                    }

                });
            })(file, dim);




        }

        SceneImpl.prototype.paintCasillero = function (node) {
            var self = this;
            var n = node;
            var file = "models/casillero.dae";


            LANA3D.AssetManager.loadBundle(file, function (result) {

                var o = result.scene;
                //o.getInternal().children[1].children[0].children[0].material.color.set(color);
                o.getLocalTransform().getPosition().add(new LANA3D.Vector3(0, 0, 0.1));
                o.getLocalTransform().scale.set(0.025, 0.025, 0.025);
                //o.getLocalTransform().setRotation(new LANA3D.Vector3(0, 0 , Math.PI / 2));
                n[0].addChild(o);
            });
        }

        SceneImpl.prototype.setSceneTransparent = function (node) {
            var self = this;
            var n = node;
            var childrenNodes = n.findChildrenByType('mesh', true);

            for (var i = 0; i < childrenNodes.length; i++) {
                var parent = childrenNodes[i].getParent();
                //var parentName = parent.getName();
                var grandParent = parent.getParent();
                var parentName = grandParent.getName();
                if (parentName.indexOf("casillero") > -1) {
                    childrenNodes[i]._internal.material.opacity = 0.30;
                }
                if (parentName.indexOf("caja") > -1) {
                    childrenNodes[i]._internal.material.opacity = 0.30;
                }
                if (parentName.indexOf("picking") > -1) {
                    childrenNodes[i]._internal.material.opacity = 0.30;
                }
                if (parentName.indexOf("palet") > -1) {
                    childrenNodes[i]._internal.material.opacity = 0.30;
                }

            }


        }

        SceneImpl.prototype.resetSceneTransparent
            = function (node) {
                var self = this;
                var n = node;
                var childrenNodes = n.findChildrenByType('mesh', true);

                for (var i = 0; i < childrenNodes.length; i++) {
                    var parent = childrenNodes[i].getParent();
                    //var parentName = parent.getName();
                    var grandParent = parent.getParent();
                    var parentName = grandParent.getName();
                    if (parentName.indexOf("casillero") > -1) {
                        childrenNodes[i]._internal.material.opacity = 1;
                    }
                    if (parentName.indexOf("caja") > -1) {
                        childrenNodes[i]._internal.material.opacity = 1;
                    }
                    if (parentName.indexOf("picking") > -1) {
                        childrenNodes[i]._internal.material.opacity = 1;
                    }
                    if (parentName.indexOf("palet") > -1) {
                        childrenNodes[i]._internal.material.opacity = 1;
                    }

                }


            }

        SceneImpl.prototype.deleteItems = function (node) {
            var self = this;
            var n = node;
            var childrenNodes = n.findChildrenByType('mesh', true);

            for (var i = 0; i < childrenNodes.length; i++) {
                var parent = childrenNodes[i].getParent();
                //var parentName = parent.getName();
                var grandParent = parent.getParent();
                var parentName = grandParent.getName();
                if (parentName.indexOf("casillero") > -1) {
                    //childrenNodes[i]._internal.material.opacity = 0;
                    parent.removeChild(childrenNodes[i]);
                }
                if (parentName.indexOf("caja") > -1) {
                    //childrenNodes[i]._internal.material.opacity = 0;
                    parent.removeChild(childrenNodes[i]);

                }
                if (parentName.indexOf("picking") > -1) {
                    //childrenNodes[i]._internal.material.opacity = 0;
                    parent.removeChild(childrenNodes[i]);

                }
                if (parentName.indexOf("palet") > -1) {
                    //childrenNodes[i]._internal.material.opacity = 0;
                    parent.removeChild(childrenNodes[i]);

                }
            }

            childrenNodes = n.findChildrenByName('state_plane', true);
            for (var i = 0; i < childrenNodes.length; i++) {
                var parent = childrenNodes[i].getParent();
                parent.removeChild(childrenNodes[i]);
            }

        }


        SceneImpl.prototype.setBuildAreaSize = function (size) {
            this._buildAreaSize = size;
            //this._worldToGrid = this._buildAreaSize/this._PFGridResolution;
        };

        VIEWER.Scene.prototype = SceneImpl.prototype;

    })(VIEWER.Impl || (VIEWER.Impl = {}));
})(VIEWER || (VIEWER = {}));

(function (VIEWER) {
    (function (ThreeImpl) {

        // Used in Viewport.Info
        Number.prototype.format = function () {
            return this.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        };

        function EditorImpl(parameters) {
            VIEWER.Editor.apply(this, arguments);
            var self = this;

            this._selectedLocation = "";
            this._selectedMachine = "";
            this._selectedMap = "";
            this._lastIntersect = null;

            this._locations = [];
            this._locationsInfo = [];

            this._editor = new Editor();
            this._viewport = new VIEWER.Viewport(this._editor);


            this._editorCamera = LANA3D.NodeManager.createNode("camera.perspective", 50, this._viewport.dom.clientWidth / this._viewport.dom.clientHeight, 0.1, 10000);
            this._editorCamera._internal = this._editor.camera;

            this._warehouseScene = new VIEWER.Scene();

            this._renderer = LANA3D.Renderer.createRenderer({ antialias: true });

            var scene = LANA3D.NodeManager.createNode("scene");
            scene._internal = this._editor.scene;
            this._renderer.setScene(scene);
            this._renderer.setCamera(this._editorCamera);
            this._renderer.getInternal().gammaInput = true;
            this._renderer.getInternal().gammaOutput = true;
            this._renderer.getInternal().setPixelRatio(window.devicePixelRatio);
            var shadows = true;
            if (shadows /*&& this._renderer.shadowMap */) {

                this._renderer.getInternal().shadowMap.enabled = true;
                this._renderer.getInternal().shadowMap.type = THREE.PCFShadowMap;

                this._renderer.getInternal().shadowCameraNear = 3;
                this._renderer.getInternal().shadowCameraFar = 5000;
                this._renderer.getInternal().shadowCameraFov = 50;

                this._renderer.getInternal().shadowMapBias = 0.0039;
                this._renderer.getInternal().shadowMapDarkness = 0.5;
                this._renderer.getInternal().shadowMapWidth = 1024;
                this._renderer.getInternal().shadowMapHeight = 1024;

            }


            this._raycaster = new THREE.Raycaster();

            this._editor.signals.rendererChanged.dispatch(this._renderer.getInternal());
            this._editor.signals.objectAdded.active = false;

            /*select object*/
            this._editor.signals.objectAdded.active = true;

            this.signals.objectSelected = new signals.Signal();
            this._editor.signals.objectSelected.add(function (object) {
                var node = object ? LANA3D.NodeManager.getInstance().getNodeFromInternal(object) : object;
                self.signals.objectSelected.dispatch(node);
            });

            this.signals.objectChanged = new signals.Signal();
            this._editor.signals.objectChanged.add(function (object) {
                var node = object ? LANA3D.NodeManager.getInstance().getNodeFromInternal(object) : object;
                self.signals.objectChanged.dispatch(node);
            });
            /**/


            //Create the RootNode
            this._scene = LANA3D.NodeManager.getInstance().createNode('scene');
            this._scene.setName("RootNode");
            this._renderer.setScene(this._editor.scene);


            this._scene.addChild(this._warehouseScene.getSceneNode());

            this._editor.addObject(this._scene.getInternal());


            var hemiLight = LANA3D.NodeManager.getInstance().createNode("light.hemisphere", 0xffffff, 0xffffff, 0.6);
            hemiLight.getInternal().color.setHSL(0.6, 1, 0.6);
            hemiLight.getInternal().groundColor.setHSL(0.095, 1, 0.75);
            hemiLight.getInternal().position.set(0, 500, 0);
            this._editor.addObject(hemiLight.getInternal());
            var dirLight = LANA3D.NodeManager.getInstance().createNode("light.directional", 0xffffff, 1);
            dirLight.getInternal().color.setHSL(0.1, 1, 0.95);
            dirLight.getInternal().position.set(0, 500, 0);
            //dirLight.position.multiplyScalar( 50 );
            dirLight.getInternal().target.position.set(0, 0, 0);
            this._editor.addObject(dirLight.getInternal());
            dirLight.getInternal().castShadow = true;

            dirLight.getInternal().shadow.mapSize.width = 2048;
            dirLight.getInternal().shadow.mapSize.height = 2048;
            var d = 3000;
            dirLight.getInternal().shadow.camera.left = -d;
            dirLight.getInternal().shadow.camera.right = d;
            dirLight.getInternal().shadow.camera.top = d;
            dirLight.getInternal().shadow.camera.bottom = -d;
            dirLight.getInternal().shadow.camera.near = 1;
            dirLight.getInternal().shadow.camera.far = 5000;

            if (shadows) {
                //    this._editor.addObject( new THREE.CameraHelper( dirLight.shadow.camera ) );
            }



            //this._editor.scene.background = new THREE.Color(0xd9dde1);
            this._editor.scene.background = new THREE.Color(0x5a6672);

            this._editor.addObject(this._scene.getInternal());

            this._editor.signals.objectAdded.active = true;

            this.signals.objectSelected = new signals.Signal();
            this._editor.signals.objectSelected.add(function (object) {
                var node = object ? LANA3D.NodeManager.getInstance().getNodeFromInternal(object) : object;
                self.signals.objectSelected.dispatch(node);
            });

            this.signals.objectChanged = new signals.Signal();
            this._editor.signals.objectChanged.add(function (object) {
                var node = object ? LANA3D.NodeManager.getInstance().getNodeFromInternal(object) : object;
                self.signals.objectChanged.dispatch(node);
            });

            $("#visor").dblclick(function (event) {
                event.preventDefault();
            });

            $("#visor").mouseup(function (event) {
                event.preventDefault();

                if (self._viewport.controls.cameraMoveMode) {
                    return;
                }


                switch (event.which) {
                    case 2:
                        //middle button
                        //reset camera position                        
                        self.getCamera().getInternal().position.set(40, 15, 0);
                        self.getCamera().getInternal().lookAt(new LANA3D.Vector3(0, 0, 0));
                        self.getCamera().getInternal().updateMatrixWorld();
                        var position = new LANA3D.Vector3(40, 15, 0);
                        self._viewport.resetCamera(position, new LANA3D.Vector3(0, 0, 0));

                        break;
                    case 1:
                        //left button
                        //object information
                        var mouse = new THREE.Vector2();
                        var restWidth = window.innerWidth - self._viewport.dom.clientWidth;
                        var restHeight = window.innerHeight - self._viewport.dom.clientHeight;
                        mouse.x = ((event.clientX - restWidth) / self._viewport.dom.clientWidth) * 2 - 1;
                        mouse.y = - ((event.clientY - restHeight) / self._viewport.dom.clientHeight) * 2 + 1;

                        self.getIntersectFirstObjectPos(mouse);
                        break;
                    case 3:
                        //right button
                        //camera to object
                        var mouse = new THREE.Vector2();
                        var restWidth = window.innerWidth - self._viewport.dom.clientWidth;
                        var restHeight = window.innerHeight - self._viewport.dom.clientHeight;
                        mouse.x = ((event.clientX - restWidth) / self._viewport.dom.clientWidth) * 2 - 1;
                        mouse.y = - ((event.clientY - restHeight) / self._viewport.dom.clientHeight) * 2 + 1;
                        self.getIntersectFirstObjectToMove(mouse);
                        break;
                }
            });

            this.getCamera().getInternal().position.set(40, 15, 0);
            this.getCamera().getInternal().lookAt(new LANA3D.Vector3(0, 0, 0));
            this.getCamera().getInternal().updateMatrixWorld();

            var clock = new THREE.Clock();

            var animate = function () {


                var delta = clock.getDelta();

                LANA3D.AnimationManager.updateAnimations(delta);
                self.render();
                requestAnimationFrame(animate);
            }

            animate();

        }

        EditorImpl.prototype = Object.create(VIEWER.Editor.prototype);

        EditorImpl.prototype.getScene = function () {
            return this._scene;
        };
        EditorImpl.prototype.setScene = function (scene) {
            this._warehouseScene.setSceneNode(scene);
        };


        EditorImpl.prototype.loadSceneFromFile = function (files) {
            var self = this;
            this._warehouseScene.loadSceneFromFile(files);
        }

        EditorImpl.prototype.addScene = function (sceneName) {
            var scene = undefined;

            if (scene != undefined) {
                this._warehouseScene.loadScene(scene);
            }

            return scene;
        };

        EditorImpl.prototype.paintItemLocations = function (locationData, currentLocations) {
            var locations = currentLocations;
            var itemLocationData = locationData;
            for (var i = 0; i < itemLocationData.length; i++) {
                var itemData = itemLocationData[i];
                var location = itemData.Location;
                var locationComplete = location + "|L|";
                for (var j = 0; j < locations.length; j++) {
                    var completeName = locations[j];
                    if (completeName.indexOf(location) >= 0) {
                        locationComplete = completeName;
                    }
                }

                var sceneNode = this._warehouseScene.getSceneNode();
                var nodo = sceneNode.findChildrenByName(locationComplete, true);
                if (nodo.length != 0) {

                    var childrenMesh = nodo[0].findChildrenByType('mesh', true);
                    for (var j = 0; j < childrenMesh.length; j++) {
                        childrenMesh[j]._internal.material.opacity = 1;
                    }

                }
                else {
                    console.log("No se ha encontrado la ubicación: " + locationComplete);
                }
            }
        }


        EditorImpl.prototype.getCompleteNameLocations = function () {
            var sceneNode = this._warehouseScene.getSceneNode();
            var locations = [];
            var locationsInfo = [];
            var children = sceneNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                children[i]._internal.traverse(function (child) {
                    var childName = child.name;

                    var n = childName.indexOf("|L|");
                    if (n >= 0) {
                        locations.push(childName);
                        locationsInfo.push(child);
                    }

                });
            }
            _locations = locations;
            _locationsInfo = locationsInfo;
            return locations;
        }

        EditorImpl.prototype.moveCameraTo = function (location, map, currentLocations) {

            var locations = currentLocations;
            var location = location;
            var locationComplete = location + "|L|";
            var locationInfo;


            for (var j = 0; j < locations.length; j++) {
                var completeName = locations[j];
                if (completeName.indexOf(location) >= 0) {
                    locationInfo = completeName.split("#");
                    var mapa = locationInfo[locationInfo.length - 1];
                    if (mapa === map) {
                        locationComplete = completeName;
                        break;
                    }
                }
            }

            var sceneNode = this._warehouseScene.getSceneNode();

            var nodo = sceneNode.findChildrenByName(locationComplete, true);

            var position = locationInfo[locationInfo.length - 2];
            if (nodo.length != 0) {

                var vector = new THREE.Vector3();
                vector.setFromMatrixPosition(nodo[0]._internal.matrixWorld);
                var children = nodo[0].findChildrenByType('mesh', true);
                if (this._lastIntersect !== null) {
                    this._lastIntersect.material.color.set(0xffffff);
                }

                children[1]._internal.material.color.set(0xff0000);
                this._lastIntersect = children[1]._internal;

                if (position === "L") {
                    this.getCamera().getInternal().position.set(vector.x - 2.25, vector.y, vector.z);
                }
                else {
                    this.getCamera().getInternal().position.set(vector.x + 2.25, vector.y, vector.z);
                }
                this.getCamera().getInternal().lookAt(new LANA3D.Vector3(vector.x, vector.y, vector.z));
                this._viewport.updateCamera(this.getCamera(), children[1]._internal);
            }
            else {
                console.log("No se ha encontrado la ubicación: " + locationComplete);
            }
        }

        EditorImpl.prototype.moveCameraToMachine = function (resource) {
            var resource = resource
            var resourceComplete = resource + "|MCH|";
            var sceneNode = this._warehouseScene.getSceneNode();
            var nodo = sceneNode.findChildrenByName(resourceComplete, true);
            if (nodo.length != 0) {
                var vector = new THREE.Vector3();
                vector.setFromMatrixPosition(nodo[0]._internal.matrixWorld);
                var children = nodo[0].findChildrenByType('mesh', true);
                if (this._lastIntersect !== null) {
                    this._lastIntersect.material.color.set(0xffffff);
                }
                var selected = this._editor.scene.getObjectByName("selectedBox", true);
                if (selected !== undefined) {
                    this._editor.scene.remove(selected);
                }

                var helper = new THREE.BoxHelper(nodo[0]._internal, 0xffffff);
                helper.name = "selectedBox";
                this._editor.scene.add(helper);
                this._lastIntersect = children[1]._internal;
                this.getCamera().getInternal().position.set(vector.x + 10, vector.y + 15, vector.z + 10);
                this.getCamera().getInternal().lookAt(new LANA3D.Vector3(vector.x, vector.y, vector.z));
                this._viewport.updateCamera(this.getCamera(), children[1]._internal);
            }
            else {
                console.log("Nodo máquina no encontrado");
            }
        }

        // recursive function to search all locations in the scene
        // they are added to a hash
        function traverseAndPopulateLocationsHash(hash, node) {
            var id = node.name;
            if (id.indexOf("|L|") != -1) {
                hash[id] = node;
                return;
            }

            var c = node.children;
            if (c.length == 0) {
                // not sure if this condition may apply.
                return;
            }

            // do the recursive call
            c.forEach(function (element) {
                traverseAndPopulateLocationsHash(hash, element);
            });
        }

        EditorImpl.prototype.paintMapOccupationStatus = function (data, currentLocations, map) {

            var t1 = Date.now();

            var locations = currentLocations;
            var occupationData = data.OccupationStatusData;
            var locationInfo;
            var dimensions = new Object();


            // create a hash [string--> node] structure
            //var t0a = Date.now();
            var sceneRoot = this._warehouseScene.getSceneNode();
            var sceneLocationsHash = {};
            traverseAndPopulateLocationsHash(sceneLocationsHash, sceneRoot);
            //var t0b = Date.now();
            //console.log (sceneLocationsHash);
            //console.log ("Hash of " + Object.keys(sceneLocationsHash).length + " elements created in " + Math.floor(t0b-t0a));


            for (var i = 0; i < occupationData.length; i++) {
                var ls = occupationData[i];
                var location = ls.Location;
                var locationComplete = location + "|L|";
                for (var j = 0; j < locations.length; j++) {
                    var completeName = locations[j];
                    if (completeName.indexOf(location) >= 0) {
                        locationComplete = completeName;

                        locationInfo = completeName.split("#");
                        var mapa = locationInfo[locationInfo.length - 1];
                        if (mapa === map) {
                            locationComplete = completeName;
                            dimensions.w = locationInfo[1];
                            dimensions.d = locationInfo[2];
                            dimensions.h = locationInfo[3];
                            break;
                        }

                    }
                }
                var status = ls.Status;
                var type = ls.LocationType;
                //if status = 1 vacía -> do not paint anything
                var sceneNode = this._warehouseScene.getSceneNode();
                //var nodo = sceneNode.findChildrenByName(locationComplete, true);

                var nodob = sceneLocationsHash[locationComplete];
                var nodo = [nodob]; // hash returns the node itself, but the rest of the code requires an array of 1 element

                if (nodo.length != 0) {
                    this._warehouseScene.paintStatus(status, type, nodo, dimensions);
                }
                else {
                    console.log("No se encuentra la locacalización en el modelo del mapa: ", locationComplete);
                }
            }
            var t2 = Date.now();
            console.log("Time paintMapOccupationStatus: " + Math.floor(t2 - t1));
        }

        EditorImpl.prototype.paintResourceStatus = function (resource, status) {
            var resource = resource;
            var status = status;
            var resourceComplete = resource + "|MCH|";

            var sceneNode = this._warehouseScene.getSceneNode();
            var nodo = sceneNode.findChildrenByName(resourceComplete, true);

            if (nodo.length != 0) {
                var childrenNodes = nodo[0].findChildrenByName('state_plane', true);
                for (var i = 0; i < childrenNodes.length; i++) {
                    var parent = childrenNodes[i].getParent();
                    parent.removeChild(childrenNodes[i]);
                }
                this._warehouseScene.paintResourceStatus(status, nodo);
            }
            else {
                console.log("No se encuentra la máquina", resourceComplete);
            }


        }

        EditorImpl.prototype.setSceneTransparent = function () {
            var sceneNode = this._warehouseScene.getSceneNode();
            this._warehouseScene.setSceneTransparent(sceneNode);
        }

        EditorImpl.prototype.resetSceneTransparent = function () {
            var sceneNode = this._warehouseScene.getSceneNode();
            this._warehouseScene.resetSceneTransparent(sceneNode);
        }

        EditorImpl.prototype.deleteItems = function () {
            var sceneNode = this._warehouseScene.getSceneNode();
            this._warehouseScene.deleteItems(sceneNode);
        }


        EditorImpl.prototype.addNode = function (node) {
            this._editor.addObject(node.getInternal());
            this._editor.moveObject(node.getInternal(), this._scene.getInternal());
        };

        EditorImpl.prototype.selectNode = function (node) {
            this._editor.select(node instanceof LANA3D.Node ? node.getInternal() : node);
        };

        EditorImpl.prototype.deleteNode = function (node) {
            if (node instanceof LANA3D.Node) {
                this._editor.removeObject(node.getInternal());
                LANA3D.NodeManager.destroyNode(node);
            }
        };

        EditorImpl.prototype.getDomElement = function () {
            return this._viewport.dom;
        };

        EditorImpl.prototype.getCamera = function () {
            return this._renderer.getCamera();
        };

        EditorImpl.prototype.resize = function () {
            this._editor.signals.windowResize.dispatch();
        };

        EditorImpl.prototype.wrapper = function (width, height) {

            this.getCamera().getInternal().aspect = width / this._viewport.dom.clientHeight;
            this.getCamera().getInternal().updateProjectionMatrix();
            this._renderer.getInternal().setSize(width, this._viewport.dom.clientHeight);
            this._viewport.dom.clientWidth = width;

        }


        EditorImpl.prototype.setBuildAreaSize = function (size) {
            this._warehouseScene.setBuildAreaSize(size);
        };

        EditorImpl.prototype.clearScene = function () {
            var objects = this._scene.getInternal().children;

            while (objects.length > 0) {
                this._editor.removeObject(objects[0]);
            }
            this._scene.addChild(this._warehouseScene.getSceneNode());

            this._editor.addObject(this._scene.getInternal());
        };

        EditorImpl.prototype.deleteScene = function () {
            this._warehouseScene.clearSceneNode();
        };

        EditorImpl.prototype.notifySelectedNodeUpdated = function () {
            this._editor.signals.objectChanged.dispatch(this._editor.selected);

        };

        EditorImpl.prototype.render = function () {
            this._editor.scene.updateMatrixWorld();
            this._renderer.render();
        };

        EditorImpl.prototype.getIntersectFirstObjectToMove = function (mouse) {
            var point = new LANA3D.Vector3(0, 0, 0);
            var validObj = false;

            this._raycaster.setFromCamera(mouse, this.getCamera().getInternal());


            var intersects = this._raycaster.intersectObjects(this._editor.scene.children, true);
            if (intersects.length > 0) {
                var vector = new THREE.Vector3();
                if (intersects[0].object.material.name.indexOf("caja") >= 0) {
                    validObj = true;

                }
                else if (intersects[0].object.material.name.indexOf("casillero") >= 0) {
                    validObj = true;

                }
                else if (intersects[0].object.material.name.indexOf("palet") >= 0) {
                    validObj = true;

                }
                else {
                    var object = intersects[0].object;
                    var isMachine = false;
                    var parent = object.parent;
                    var resource = "";
                    while (!isMachine) {
                        if (parent.name.indexOf("|MCH|") >= 0) {
                            isMachine = true;
                            resource = parent.name;
                        }
                        else {
                            parent = parent.parent;
                            if (parent === null) {
                                break;
                            }
                        }
                    }
                    if (isMachine) {
                        validObj = true;
                    }
                }

                if (validObj) {
                    vector.setFromMatrixPosition(intersects[0].object.matrixWorld);

                    this.getCamera().getInternal().lookAt(new LANA3D.Vector3(vector.x, vector.y, vector.z));
                    this._viewport.updateCamera(this.getCamera(), intersects[0].object);

                }

            }
        }


        EditorImpl.prototype.getIntersectFirstObjectPos = function (mouse) {
            var point = new LANA3D.Vector3(0, 0, 0);
            var boxSelected = false;


            var selected = this._editor.scene.getObjectByName("selectedBox", true);
            if (selected !== undefined) {
                this._editor.scene.remove(selected);
            }

            this._raycaster.setFromCamera(mouse, this.getCamera().getInternal());


            var intersects = this._raycaster.intersectObjects(this._editor.scene.children, true);
            if (intersects.length > 0) {

                for (var i = 0; i < intersects.length; i++) {

                    var intersect = intersects[i];

                    if (intersect.object.material.name.indexOf("caja") >= 0) {
                        this.findLocation(intersect.object);
                        if (this._lastIntersect !== null) {
                            this._lastIntersect.material.color.set(0xffffff);
                        }
                        intersect.object.material.color.set(0xff0000);
                        this._lastIntersect = intersect.object;
                        boxSelected = true;
                        break;

                    }
                    if (intersect.object.material.name.indexOf("casillero") >= 0) {
                        this.findLocation(intersect.object);
                        if (this._lastIntersect !== null) {
                            this._lastIntersect.material.color.set(0xffffff);
                        }
                        intersect.object.material.color.set(0xff0000);
                        this._lastIntersect = intersect.object;
                        boxSelected = true;
                        break;

                    }
                    if (intersect.object.material.name.indexOf("palet") >= 0) {
                        this.findLocation(intersect.object);
                        if (this._lastIntersect !== null) {
                            this._lastIntersect.material.color.set(0xffffff);
                        }
                        intersect.object.material.color.set(0xff0000);
                        this._lastIntersect = intersect.object;
                        boxSelected = true;
                        break;

                    }

                    //check if it is machine
                    var object = intersect.object;
                    var isMachine = false;
                    var parent = object.parent;
                    var resource = "";
                    while (!isMachine) {
                        if (parent.name.indexOf("|MCH|") >= 0) {
                            isMachine = true;
                            resource = parent.name;
                        }
                        else {
                            parent = parent.parent;
                            if (parent === null) {
                                break;
                            }
                        }
                    }
                    if (isMachine) {
                        var sceneNode = this._warehouseScene.getSceneNode();
                        var nodo = sceneNode.findChildrenByName(resource, true);

                        this._selectedMachine = parent.parent.name + "#" + resource.substring(0, resource.indexOf("|MCH|"));
                        var helper = new THREE.BoxHelper(nodo[0]._internal, 0xffffff);
                        helper.name = "selectedBox";
                        this._editor.scene.add(helper);
                        $("#machineModal").modal();
                        break;
                    }
                }
                if (!boxSelected) {
                    if (this._lastIntersect !== null) {
                        this._lastIntersect.material.color.set(0xffffff);
                    }
                    this._lastIntersect = null;
                }
            }

            return point;
        };

        EditorImpl.prototype.findLocation = function (object) {
            var object = object;
            var parentName = object.name;

            while (parentName.indexOf("|L|") < 0) {
                object = object.parent;
                parentName = object.name;
            }
            this._selectedLocation = parentName.substring(0, parentName.indexOf("|L|"));
            this._selectedMap = parentName.substring(parentName.lastIndexOf("#") + 1);
            $("#productModal").modal();
        }

        EditorImpl.prototype.getSelectedLocation = function () {
            return this._selectedLocation;
        }

        EditorImpl.prototype.getSelectedMachine = function () {
            return this._selectedMachine;
        }

        EditorImpl.prototype.getSelectedMap = function () {
            return this._selectedMap;
        }


        EditorImpl.prototype.getIntersectFloorObjectPos = function (mouse) {
            var point = new LANA3D.Vector3(0, 0, 0);

            this._raycaster.setFromCamera(mouse, this.getCamera().getInternal());

            var intersects = this._raycaster.intersectObjects(this._editor.scene.children);

            for (var i = 0; i < intersects.length; i++) {

                var intersect = intersects[i];
                if (intersect.object.name == "floor_plane") {
                    point.x = intersect.point.x; point.y = intersect.point.y; point.z = intersect.point.z;
                    return point;
                }
            }

            return point;
        };


        EditorImpl.prototype.toogleDebug = function () {
            this._debugNodeVisu.getInternal().visible = !this._debugNodeVisu.getInternal().visible;
        };


        EditorImpl.prototype.removeSceneElements = function () {

            var node = this._debugNodeVisu.findChildrenByName("pathPoints");
            for (var i = 0; i < node.length; i++) {
                this._debugNodeVisu.removeChild(node[i]);
            }

        };


        function create(parameters) {
            return new EditorImpl(parameters);
        }


        VIEWER.Editor.create = create;

    })(VIEWER.Three || (VIEWER.Three = {}));
})(VIEWER || (VIEWER = {}));

